// 画面サイズに応じてテーブルの表示を切り替えるスクリプト
$(document).ready(function () {
  function toggleTableDisplay() {
    const tablePc = $('.p-rentacar-table-pc');
    const tableSp = $('.p-rentacar-table-sp');
    
    if (window.innerWidth < 1200) {
      tablePc.hide();
      tableSp.show();
    } else {
      tablePc.show();
      tableSp.hide();
    }
  }
  
  // 初期表示時に実行
  toggleTableDisplay();
  
  // ウィンドウサイズ変更時にも実行
  $(window).resize(function() {
    toggleTableDisplay();
  });
});